module.exports = __webpack_public_path__ + "static/media/Illus-Pickup_1@2x.fca06292.png";